import { render, staticRenderFns } from "./registration-form-modal.vue?vue&type=template&id=23b7da68&scoped=true&"
import script from "./registration-form-modal.ts?vue&type=script&lang=ts&"
export * from "./registration-form-modal.ts?vue&type=script&lang=ts&"
import style0 from "./registration-form-modal.scss?vue&type=style&index=0&id=23b7da68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b7da68",
  null
  
)

export default component.exports